import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';
import Markdown from 'preact-markdown';

import localUtil from '../../lib/util';
import fields from '../../lib/fields';
import { getHideFields } from '../../lib/editFieldsConfig';

import FormFieldsCompact from '../../components/form/fieldsCompact';
import Input from '../../components/form/input';

@withText(props => ({
    conventionNumber: <Text id='input.conventionNumber-help'>conventionNumber</Text>,
    name: <Text id='input.name-help'>name</Text>,
    description: <Text id='input.description-help'>description</Text>,
    url: <Text id='input.url-help'>url</Text>,
}))
@observer
class NewConvention extends Component {
  	constructor(props) {
        super(props);
        this.state = {
            sections: fields.get('convention'),
            showCopyStands: false,
            copySourceList: [],
            copySourceLoaded: false,
            copySourceLoading: false,
            copySourceSearch: '',
            armedCopySourceId: null,
            copyStandsInProgress: false,
        };
    }

    loadAll = async (props = this.props, emptyFirst = true) => {
        const { id, isNew } = props;
        const { conventionStore } = this.props.stores;
        if (emptyFirst) {
            // conventionStore.updateKeyValue('convention', {});
        }
        await conventionStore.load(id, false, {
            addData: ['tags', 'members', 'allMembers'],
            query: {
                hostname: conventionStore.currentHostname,
            },
        });
        const { members } = conventionStore;
        if (members && members.length > 0) {
            conventionStore.updateKeyValue('adminMembers', members);
        }
        if (isNew) {
            conventionStore.loadIntoNew({
                id: null,
                fields: [
                    'public',
                    'title',
                    'startDate',
                    'endDate',
                    'registrationIsOpen',
                    'registrationStartDate',
                    'registrationEndDate',
                    'stageInterval',
                    'stageSlots',
                    'stageGapHours',
                    'members',
                    'tags',
                    'description',
                    'sponsors',
                    'stageStands',
                    'stageStandsSpecial',
                    'stageStandsMagnum',
                    'stageStandImages',
                    'rangeDescription',
                ],
                query: {
                    hostname: conventionStore.currentHostname,
                },
            });
        }
    }

    createConvention = async () => {
        const { callback = () => {} } = this.props;
        const { conventionStore } = this.props.stores;
        const { newConvention } = conventionStore;

        const response = await conventionStore.insert(newConvention);

        conventionStore.updateKeyValue('newConvention', {});
        callback();
    }

    chooseItem = (e) => {
        const { id } = e.target.closest('.similar-item').dataset;
        const { conventionStore } = this.props.stores;
        const { foundList } = conventionStore;
        const item = foundList.find((item) => item.id === parseInt(id, 10));
        conventionStore.updateKeyValue('newConvention', {
            ...item,
        });
        conventionStore.resetSearch();
    }

    toggleSimilar = () => {
        const { showSimilar } = this.state;
        this.setState({
            showSimilar: !showSimilar,
        });
    }

    toggleCopyStands = async () => {
        const { showCopyStands, copySourceLoaded } = this.state;
        if (showCopyStands) {
            this.setState({ showCopyStands: false, armedCopySourceId: null });
            return;
        }
        this.setState({ showCopyStands: true });
        if (!copySourceLoaded) {
            await this.loadCopySourceList();
        }
    }

    loadCopySourceList = async () => {
        const { conventionStore } = this.props.stores;
        const { convention } = conventionStore;
        this.setState({ copySourceLoading: true });
        const conventions = await conventionStore.load({
            query: {
                hostname: conventionStore.currentHostname,
            },
            sort: '-startDate',
            limit: 100,
            skipUpdate: true,
        });
        const copySourceList = (Array.isArray(conventions) ? conventions : []).filter(c => c.id !== convention.id
            && (c.stageStands?.length > 0 || c.stageStandImages?.length > 0 || !!c.rangeDescription));
        this.setState({ copySourceList, copySourceLoaded: true, copySourceLoading: false });
    }

    handleCopySourceSearch = (e) => {
        this.setState({ copySourceSearch: e.target.value, armedCopySourceId: null });
    }

    copyStandsFrom = async (source) => {
        const { armedCopySourceId, copyStandsInProgress } = this.state;
        if (copyStandsInProgress) {
            return;
        }
        // First click arms the row; the copy replaces existing stands/images,
        // so require a second click on the same row to confirm.
        if (armedCopySourceId !== source.id) {
            this.setState({ armedCopySourceId: source.id });
            return;
        }
        const { appState, conventionStore } = this.props.stores;
        const { convention } = conventionStore;
        this.setState({ copyStandsInProgress: true });
        const response = await conventionStore.save({
            id: convention.id,
            'stageStands-overwrite': source.stageStands || [],
            'stageStandsSpecial-overwrite': source.stageStandsSpecial || [],
            'stageStandsMagnum-overwrite': source.stageStandsMagnum || [],
            'stageStandImages-overwrite': source.stageStandImages || [],
            rangeDescription: source.rangeDescription || '',
        });
        this.setState({ copyStandsInProgress: false, armedCopySourceId: null });
        if (response && response.status >= 200 && response.status < 300) {
            this.setState({ showCopyStands: false });
            await this.loadAll(this.props, false);
            appState.addToast({ type: 'success', message: <Text id='convention.copy-stands-success'>Stands, stand images and range description copied</Text> });
        } else {
            appState.addToast({ type: 'error', message: <Text id='convention.copy-stands-failed'>Could not copy stands</Text> });
        }
    }

    openFieldsSettings = () => {
        const { drawerLevel = 1 } = this.props;
        const { appState } = this.props.stores;
        const { drawerHeightMediumLarge } = appState;
        appState.openDrawer('editFieldsSettings', {
            entityType: 'convention',
            height: drawerHeightMediumLarge,
        }, drawerLevel + 1);
    }

    componentDidMount() {
        this.loadAll();
    }

    render() {
        const { week, isNew, drawerLevel, installation, lookupArray } = this.props;
        const {
            sections, showSimilar, showCopyStands, copySourceList,
            copySourceLoading, armedCopySourceId, copyStandsInProgress, copySourceSearch,
        } = this.state;
        const copySourceSearchLower = copySourceSearch.toLowerCase().trim();
        const filteredCopySourceList = copySourceSearchLower ? copySourceList.filter(c => {
            const dateStr = c.startDate ? util.formatDate(c.startDate, {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
                locale: 'nb-NO',
            }) : '';
            return `${c.title || ''} ${dateStr}`.toLowerCase().includes(copySourceSearchLower);
        }) : copySourceList;
        const { userStore, conventionStore } = this.props.stores;
        const { user, isAdmin, isCustomerAdmin, customer = {} } = userStore;
        const hideFields = getHideFields(customer, 'convention');
        const { newConvention, foundList, foundListKeys } = conventionStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        return (<>
            <div class='w-100 d-flex justify-content-center position-relative'>
                <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>
                    {/* <div class='w-100 d-flex flex-column justify-content-start'>
                        <xmp>{JSON.stringify(user.settings, null, 2)}</xmp>
                    </div> */}
                    {/* <xmp>{JSON.stringify(newCustomer, null, 4)}</xmp> */}
                    {/* <xmp>{JSON.stringify(installation, null, 4)}</xmp> */}
                    <div class='font-weight-lighter px-3 box-header mt-0 d-flex flex-row justify-content-between align-items-center'>
                        <span>
                            {isNew ? <Text id='convention.new'>New convention</Text> : <Text id='convention.edit'>Edit convention</Text>}
                        </span>
                        {/* me-5 keeps the cog clear of the drawer close X when the drawer is no wider than the content column. */}
                        {isCustomerAdmin && <button type='button' class='btn btn-sm btn-outline-secondary rounded-circle me-5'
                            onClick={this.openFieldsSettings}>
                            <i class='fa-solid fa-gear' />
                        </button>}
                    </div>

                    {!isNew && <div class='w-100 d-flex flex-column px-3 mt-2'>
                        <div>
                            <button type='button' class='btn btn-sm btn-outline-primary rounded-pill' onClick={this.toggleCopyStands}>
                                <i class='fa-duotone fa-copy me-2' />
                                <Text id='convention.copy-stands-from-other'>Copy stands from another convention</Text>
                            </button>
                        </div>
                        {showCopyStands && <div class='mt-2'>
                            <small class='text-body-secondary d-block mb-2'>
                                <Text id='convention.copy-stands-replaces'>Copies stands, max special/magnum, stand images and the range description. Existing values on this convention are replaced.</Text>
                            </small>
                            {copySourceLoading && <div class='text-body-secondary'>
                                <i class='fa-duotone fa-spinner-third fa-spin me-2' />
                                <Text id='convention.copy-stands-loading'>Loading conventions...</Text>
                            </div>}
                            {!copySourceLoading && copySourceList.length === 0 && <div class='text-body-secondary'>
                                <Text id='convention.copy-stands-none-found'>No other conventions with stands or stand images found.</Text>
                            </div>}
                            {!copySourceLoading && copySourceList.length > 0 && <>
                                <Localizer>
                                    <input
                                        class='form-control form-control-sm mb-2'
                                        type='text'
                                        placeholder={<Text id='convention.copy-stands-search'>Search conventions...</Text>}
                                        value={copySourceSearch}
                                        onInput={this.handleCopySourceSearch}
                                    />
                                </Localizer>
                                {filteredCopySourceList.length === 0 && <div class='text-body-secondary'>
                                    <Text id='convention.copy-stands-no-match'>No conventions match your search.</Text>
                                </div>}
                            </>}
                            {!copySourceLoading && filteredCopySourceList.length > 0 && <div class='list-group'>
                                {filteredCopySourceList.map(source => <button
                                    type='button'
                                    key={source.id}
                                    class={`list-group-item list-group-item-action d-flex flex-row justify-content-between align-items-center ${armedCopySourceId === source.id ? 'list-group-item-warning' : ''}`}
                                    disabled={copyStandsInProgress}
                                    onClick={() => this.copyStandsFrom(source)}
                                >
                                    <span class='d-flex flex-column text-start'>
                                        <strong>{source.title}</strong>
                                        <small class='text-body-secondary'>
                                            {source.startDate ? util.formatDate(source.startDate, {
                                                day: '2-digit',
                                                month: 'short',
                                                year: 'numeric',
                                                locale: 'nb-NO',
                                            }) : ''}
                                        </small>
                                    </span>
                                    <span class='text-end'>
                                        {armedCopySourceId === source.id ? <small class='fw-bold'>
                                            {copyStandsInProgress ? <i class='fa-duotone fa-spinner-third fa-spin' /> : <Text id='convention.copy-stands-confirm'>Click again to confirm</Text>}
                                        </small> : <small>
                                            {source.stageStands?.length > 0 && <span class='badge bg-secondary ms-1'>
                                                {source.stageStands.length} <Text id='convention.copy-stands-stands'>stands</Text>
                                            </span>}
                                            {source.stageStandImages?.length > 0 && <span class='badge bg-secondary ms-1'>
                                                {source.stageStandImages.length} <Text id='convention.copy-stands-images'>images</Text>
                                            </span>}
                                        </small>}
                                    </span>
                                </button>)}
                            </div>}
                        </div>}
                    </div>}

                    <div class='w-100 d-flex flex-column justify-content-start'>
                        <div class='bg-light d-flex flex-column justify-content-start h-100 pt-3'>
                            <FormFieldsCompact
                                stores={this.props.stores}
                                sections={sections}
                                holdingStore={conventionStore}
                                objectName={isNew ? 'newConvention' : 'convention'}
                                isNew={isNew}
                                defaultShowOnlyRecommended={true}
                                drawerLevel={drawerLevel}
                                isAdmin={false}
                                hideAdmin={true}
                                hideFields={hideFields}
                                lookupArray={lookupArray}
                                rightHeader={isNew && foundList?.length > 0 ? <span class='text-success font-weight-bold'><i class='fa-solid fa-circle-info' /> Similar conventions ({foundList.length})</span> : null}
                                rightHeaderClick={this.toggleSimilar}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {isNew && <div class='w-100 d-flex flex-column justify-content-start mt-3 px-4 py-3 bg-light fixed-bottom' style={`bottom: 0; left: 0;`}>
                <button type='button' class='btn btn-primary rounded-pill' onClick={this.createConvention}>
                    {isNew ? <Text id='convention.create'>Create convention</Text> : <Text id='convention.save'>Save convention</Text>}
                </button>
            </div>}
        </>);
    }
}

export default NewConvention;
